import { useAddress } from "../hooks/useAddress";

const GeocodeResolved = ({ lat, lng }) => {
  const { address } = useAddress({ lat, lng });
  if (address === null) return <span>{"-"}</span>;
  if (!address.fullAddress && !address.address) return <span>{"주소 확인 불가"}</span>;
  return <span>{address.fullAddress ?? address.address}</span>;
};

export const Geocode = ({ lat, lng }) => {
  if (lat == null || lng == null) return <span>{"없음"}</span>;
  return <GeocodeResolved lat={lat} lng={lng} />;
};
